import { Directive, ViewContainerRef } from '@angular/core'

/**
 * @description Used to specific the container reference to inject the dynamic components into it
 */
@Directive({
    selector: '[zoneHost]',
    standalone: false
})
export class ZoneDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
